import * as React from "react";
import type { SVGProps } from "react";
const SvgConciergeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M12.215 5.6a.564.564 0 0 0 .105 1.12h1.12v.56h1.12v-.56h1.12a.56.56 0 0 0 .492-.278c.1-.175.1-.39 0-.564a.56.56 0 0 0-.492-.278h-3.465M14 7.84c-6.797 0-12.32 5.523-12.32 12.32h-.56c-.613 0-1.12.507-1.12 1.12v2.24c0 .612.507 1.12 1.12 1.12h25.76c.613 0 1.12-.508 1.12-1.12v-2.24c0-.613-.508-1.12-1.12-1.12h-.56c0-6.797-5.523-12.32-12.32-12.32m0 1.12a11.19 11.19 0 0 1 11.2 11.2H2.8A11.19 11.19 0 0 1 14 8.96M1.12 21.28h25.76v2.24H1.12z"
    />
  </svg>
);
export default SvgConciergeIcon;
